module.exports = __webpack_public_path__ + "img/pic-qrcode-1.d9e95eac.jpg";